export const calculateAnalyticPercent = (currentValue, prevValue) => {
    if (currentValue === prevValue)
        return 0;
    else if (prevValue === 0 && currentValue > 0)
        return null;
    else if (currentValue === 0 && prevValue > 0) {
        return -100;
    }
    else {
        const difference = currentValue - prevValue;
        return ((difference * 100) / prevValue).toFixed(0);
    }
};
export const zeroPad = (num) => String(num).padStart(2, "0");
export const getFormattedDuration = (input) => {
    let formattedDuration = "";
    if (input.hours > 0) {
        formattedDuration = formattedDuration.concat(`${input.hours}h`);
    }
    if (input.minutes > 0) {
        formattedDuration = formattedDuration.concat(` ${input.minutes}m`);
    }
    if (input.seconds > 0) {
        formattedDuration = formattedDuration.concat(` ${input.seconds}s`);
    }
    return formattedDuration;
};
/**
 * Requires the array to be in the format of [{ name: string, value: number }]
 * @param ticksLength
 * @param formattedToursTimeData
 * @returns
 */
export function getYAxisTicks(ticksLength = 4, formattedToursTimeData) {
    if (!(formattedToursTimeData === null || formattedToursTimeData === void 0 ? void 0 : formattedToursTimeData.length))
        return undefined;
    const valueSet = Array.from(new Set(formattedToursTimeData.map((item) => item.value)));
    const maxValue = Math.ceil(Math.max(...valueSet));
    if (maxValue <= ticksLength) {
        return Array.from({ length: maxValue }, (_, i) => i + 1);
    }
    const remainder = maxValue % ticksLength;
    const closestNumber = maxValue + ticksLength - remainder;
    return Array.from({ length: ticksLength }, (_, i) => (i + 1) * (closestNumber / ticksLength));
}
export function minutesToHoursFormat(minutes) {
    const hours = minutes / 60;
    if (hours === 12) {
        return `${hours} PM`;
    }
    else if (hours > 12) {
        return `${hours - 12} PM`;
    }
    return `${hours} AM`;
}
export function hoursFromMinutes(minutes) {
    return minutes / 60;
}
/**
 * Formats a value to a number with no decimals if the value is a round number
 * @param value number to format
 */
export function formatPercentageDecimals(value) {
    return value % 1 === 0 ? value.toFixed(0) : value.toFixed(1);
}
